var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStairsmaster(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3333 12.6667C14.3333 12.1144 14.781 11.6667 15.3333 11.6667H19.3333C19.8856 11.6667 20.3333 12.1144 20.3333 12.6667V16.6667C20.3333 17.2189 19.8856 17.6667 19.3333 17.6667C18.781 17.6667 18.3333 17.2189 18.3333 16.6667V13.6667H15.3333C14.781 13.6667 14.3333 13.2189 14.3333 12.6667Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3333 2C14.3333 1.44772 14.781 1 15.3333 1H22C22.5523 1 23 1.44772 23 2C23 2.55228 22.5523 3 22 3H16.3333V8.66668C16.3333 9.21897 15.8856 9.66668 15.3333 9.66668H9.66668V15.3333C9.66668 15.8856 9.21897 16.3333 8.66668 16.3333H3V22C3 22.5523 2.55228 23 2 23C1.44772 23 1 22.5523 1 22V15.3333C1 14.781 1.44772 14.3333 2 14.3333H7.66668V8.66668C7.66668 8.1144 8.1144 7.66668 8.66668 7.66668H14.3333V2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3736 12.6262C19.7641 13.0167 19.7641 13.6499 19.3736 14.0404L13.3736 20.0404C12.9831 20.4309 12.3499 20.4309 11.9594 20.0404C11.5689 19.6499 11.5689 19.0167 11.9594 18.6262L17.9594 12.6262C18.3499 12.2357 18.9831 12.2357 19.3736 12.6262Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStairsmaster);
export default __webpack_public_path__ + "static/media/stairsmaster.f2d2647d420da58e4322498e3db468f6.svg";
export { ForwardRef as ReactComponent };